// utils/i18n.js が既に window.i18nStore を定義しているため、
// このファイルは languages.json の非同期ロード + フォールバック (13 言語) を提供する。
// 旧旧版踏襲: 100+ 言語 (assets/languages.json) を Google 翻訳ベースで対応。
;(function () {
  if (!window.i18nStore) {
    console.warn('[i18nStore] utils/i18n.js が先に読み込まれていません');
    return;
  }

  // 初期フォールバック (languages.json fetch 失敗時 + 起動直後の表示用)
  const FALLBACK = [
    { code: 'ja', english_name: 'Japanese', local_name: '日本語' },
    { code: 'en', english_name: 'English', local_name: 'English' },
    { code: 'zh', english_name: 'Chinese (Simplified)', local_name: '中文' },
    { code: 'ko', english_name: 'Korean', local_name: '한국어' },
    { code: 'vi', english_name: 'Vietnamese', local_name: 'Tiếng Việt' },
    { code: 'th', english_name: 'Thai', local_name: 'ไทย' },
    { code: 'es', english_name: 'Spanish', local_name: 'Español' },
    { code: 'pt', english_name: 'Portuguese', local_name: 'Português' },
    { code: 'fr', english_name: 'French', local_name: 'Français' },
    { code: 'de', english_name: 'German', local_name: 'Deutsch' },
    { code: 'it', english_name: 'Italian', local_name: 'Italiano' },
    { code: 'ru', english_name: 'Russian', local_name: 'Русский' },
    { code: 'ar', english_name: 'Arabic', local_name: 'العربية' }
  ];

  // Vue.reactive にして言語選択モーダルが動的に追従できるようにする
  window.i18nStore.languages = Vue.reactive([...FALLBACK]);

  // 非同期で languages.json (100+ 言語) を読み込み、 reactive 配列を差し替える
  // (失敗してもフォールバックの 13 言語で動作継続)
  fetch('/assets/languages.json')
    .then((r) => (r.ok ? r.json() : null))
    .then((data) => {
      if (!Array.isArray(data) || data.length === 0) return;
      // english_name でソート (旧版 ModalLanguageSelector.vue:29 踏襲)
      data.sort((a, b) => (a.english_name || '').localeCompare(b.english_name || ''));
      // reactive を維持したまま中身を入れ替え (Vue 3 reactivity 保持)
      window.i18nStore.languages.splice(0, window.i18nStore.languages.length, ...data);
    })
    .catch((e) => console.warn('[i18nStore] languages.json fetch 失敗、 フォールバック 13 言語で続行:', e));
})();
